import r from"../formatMuiErrorMessage/formatMuiErrorMessage.js";function e(e){if("string"!=typeof e)throw new Error(r(7));return e.charAt(0).toUpperCase()+e.slice(1)}export{e as default};
//# sourceMappingURL=capitalize.js.map
